import React from "react";
import "./ExportPdfButton.scss";

export function ExportPdfButton({ onClick, loading = false, title = "Exportar PDF" }) {
  return (
    <button className="export-pdf-btn" onClick={onClick} disabled={loading} title={title}>
      {loading
        ? <i className="spinner loading icon" style={{ color: "#555" }} />
        : <i className="download icon" style={{ color: "#555" }} />}
    </button>
  );
}
